import { render, staticRenderFns } from "./caixas.vue?vue&type=template&id=d73aba04"
import script from "./caixas.vue?vue&type=script&lang=js"
export * from "./caixas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports